<template>
  <div id="event-live-donation-item-list" class="event-live-donation-item-list-wrap only_logged_in">
    <div class="event-live-donation-item-list--list">
      <div v-for="(sku, index) in skus" class="event-live-donation-item-list--row" v-on:click="doDonation(sku)" >
        <img v-bind:src="sku.image_url" class="pg-event-live-donation-item-list--image__little">
        <p class="event-live-donation-item-list--label__gray">¥{{sku.sku_price_delimited}}</p>
      </div>
    </div>
    <div class="pg-live--section--sp_only">
      <div id="removeDonationButton" class="submit button-blue center-button pg-event-live-donation-item-list--button--dark" onclick="closeSpDonationSection()">閉じる</div>
    </div>
    <input type="hidden" name="skuId" :value="skuId" class="select-event-live-donation-item-id">
    <input type="hidden" name="skuImage" :value="skuImage" class="select-event-live-donation-item-image">
    <input type="hidden" name="skuName" :value="skuName" class="select-event-live-donation-item-name">
    <input type="hidden" name="skuPrice" :value="skuPrice" class="select-event-live-donation-item-name">
    <input type="hidden" name="skuOverview" :value="skuOverview" class="select-event-live-donation-item-name">
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'
  import axios from "axios";

  export default {
    name: "EventLiveDonationItemList",
    props: {
      get_skus_path: { type: String, required: true },
      current_user: { type: String, required: true },
      new_user_session_path: { type: String, required: true },
    },
    data: () => ({
      skuId: "",
      skuImage: "",
      skuName: "",
      skuPrice: "",
      skuOverview: ""
    }),
    firestore() {
    },
    computed: {
      consts: function() {
        return consts
      },
      skus: function() {
        return this.$store.getters['sku/skus']
      },
      isCurrentUser() {
        return this.current_user;
      }
    },
    methods: {
      doDonation: function(sku){
        this.skuId = sku.id
        this.skuImage = sku.image_url
        this.skuName = sku.name
        this.skuPrice = sku.sku_price_delimited
        this.skuOverview = sku.overview
        setDonationTarget(this.skuId, this.skuImage, this.skuName, this.skuPrice, sku.overview)
        if (!this.isCurrentUser) {
          window.location.href = this.new_user_session_path;
          return;
        }
        $('.event-live-donation--wrap').show()
        var animationSpeed = 150
        if(PC_MIN_WIIDTH > window.innerWidth){
          $('.pg-live__section__donation').hide()
          var event_live_donation_height = "47vh"
          $('#event-live-donation').animate({height:"45vh"}, animationSpeed, "linear");
          $('#event-live-donation--state--processing').animate({height:event_live_donation_height}, animationSpeed, "linear");
          $('#event-live-donation--state--complete').animate({height:event_live_donation_height}, animationSpeed, "linear");
          $('#event-live-donation--state--fail-before-charge').animate({height:event_live_donation_height}, animationSpeed, "linear");
          $('#event-live-donatifon--state--fail-after-charge').animate({height:event_live_donation_height}, animationSpeed, "linear");
        } else {
          $('#event-live-donation').animate({width:"300px"}, animationSpeed, "linear");
          $('#event-live-donation--state--processing').animate({width:"300px"}, animationSpeed, "linear");
          $('#event-live-donation--state--complete').animate({width:"300px"}, animationSpeed, "linear");
          $('#event-live-donation--state--fail-before-charge').animate({width:"300px"}, animationSpeed, "linear");
          $('#event-live-donation--state--fail-after-charge').animate({width:"300px"}, animationSpeed, "linear");
          setTimeout(function(){
            $('.pg-event-live-donation--wrap--buttons').css('margin-top', '0px')
            var button_pos = $('#event-live-donation').outerHeight() - ($('.pg-event-live-donation--wrap--buttons').position().top + $('.pg-event-live-donation--wrap--buttons').height())
            if (button_pos > 0) {
              $('.pg-event-live-donation--wrap--buttons').css('margin-top', button_pos + 110)
            }
          }, 150);
        }

        $('#event-live-donation').animate({scrollTop: 0}, 'fast')
      },
      isDonationProcessingOrEnded: function(){
        if ($('#event-live-donation--state--processing').is(':visible') ||
            $('#event-live-donation--state--complete').is(':visible') ||
            $('#event-live-donation--state--fail-before-charge').is(':visible') ||
            $('#event-live-donation--state--fail-after-charge').is(':visible')) {
            return true;
        }
        return false;
      },
    },
    watch: {
    },
    created(){
      this.$store.dispatch('sku/getDonationSkus', {api_path: this.get_skus_path}).then(() => {
        setCustomStyle('#event-live-donation-item-list')
      })
    },
    mounted: function () {
    }
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  .event-live-donation-item-list-wrap {
    min-height: 150px;

    @media screen and (max-width: 1340px) {
      min-height: 350px;
    }

    @media screen and (max-width: 1000px) {
      margin-bottom: 0px;
      min-height: 0;
    }
  }

  .event-live-donation-item-list--list {

    @media screen and (max-width: 1000px) {
      width: 100%;
      height: 0;
      padding: 20px 0 0 0;
      text-align: center;
      display: inline-block;
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }

  .event-live-donation-item-list--list::-webkit-scrollbar {
    display:none;
  }

  .event-live-donation-item-list--row {
    cursor: pointer;
    display: inline-table;

    @media screen and (max-width: 1000px) {
      width: 60px;
      display: inline-grid;
      margin: 0 10px;
    }
  }

  .event-live-donation-item-list--row:hover {
    opacity: 0.5;
  }

  .pg-event-live-donation-item-list--image__little {
    width: 80px;
    height: 80px;
    object-fit: cover;

    @media screen and (max-width: 1000px) {
      width: 60px;
      height: 60px;
    }
  }

  .pg-event-live-donation-item-list--button {
    width: 100%;
    margin: 0;
  }

  .pg-event-live-donation-item-list--button:disabled {
    opacity: 0.5;
  }

  .pg-event-live-donation-item-list--button--dark {
    @extend .pg-event-live-donation-item-list--button;
    background-color: #666666;
  }

  .event-live-donation-item-list--label__gray {
    margin: 13px 0;
    color: #666666;
    font-size: 11px;
    text-align: center;
  }

</style>
